module.exports = __webpack_public_path__ + "img/eliezer.b35b91a0.jpg";